import React from 'react';
import './AddMissionRow.css';

/**
 * AddMissionRow - Button to add a new mission at a specific nesting level
 * 
 * When clicked, creates a new mission and triggers edit mode on it,
 * exactly like the "+ Mission" button in the toolbar.
 * 
 * @param depth - Nesting depth for indentation (matches TodoItem)
 * @param onAddMission - Callback to create mission (no args, just like toolbar)
 * @param campaignName - Optional campaign name to display (for nested campaigns)
 */
const AddMissionRow = ({ depth = 0, onAddMission, campaignName }) => {
  // Calculate indentation to match TodoItem's left edge
  // TodoItem uses: basePadding (12 for non-parent) + indentPadding (depth * 20)
  const indentPadding = depth * 20;
  const basePadding = 12;
  const marginLeft = basePadding + indentPadding;

  const handleClick = () => {
    onAddMission?.();
  };

  // Build the button text
  const buttonText = campaignName 
    ? `Add mission to ${campaignName}`
    : 'Add mission';

  return (
    <button
      className="add-mission-row"
      style={{ marginLeft: `${marginLeft}px` }}
      onClick={handleClick}
      type="button"
    >
      <span className="add-mission-row__icon">+</span>
      <span className="add-mission-row__text">{buttonText}</span>
    </button>
  );
};

export default AddMissionRow;
